import cx from "../../../lib/cx";
import styles from "./textarea.css";

/**
 * Renders a customizable textarea component with label, validation, and error message display.
 *
 * @param {Object} params - The parameters for the Textarea component.
 * @param {string} params.name - The name attribute of the textarea.
 * @param {string} params.label - The label text displayed for the textarea.
 * @param {string} params.value - The current value of the textarea.
 * @param {string} params.placeholder
 * @param {boolean} [params.required=false] - Indicates if the textarea is required.
 * @param {Function} params.onChange - The callback function to handle the onChange event.
 * @param {string} [params.error] - The error message displayed when validation fails.
 * @param {number} [params.minLength] - The minimum allowable length for the textarea value.
 * @param {number} [params.maxLength] - The maximum allowable length for the textarea value.
 * @param {boolean} [params.width100=false] - If true, the textarea will take 100% width of its parent container.
 * @param {Function} [params.onBlur] - The callback function to handle the onBlur event.
 * @param {string} [params.theme]
 * @param {boolean} [params.fullHeight=false] - If true, the textarea will take 100% width of its parent container.
 * @return {JSX.Element} A rendered textarea component.
 */
function Textarea({
  name,
  label,
  value,
  required = false,
  onChange,
  error,
  minLength,
  maxLength,
  width100 = false,
  fullHeight = true,
  onBlur,
  theme = "light",
  placeholder,
}) {
  return (
    <div
      className={cx(
        styles.control[error ? "error" : "default"],
        width100 && styles.wide,
      )}
    >
      <textarea
        className={cx(
          styles.inputText[theme],
          fullHeight ? styles.high : styles.compact,
        )}
        name={name}
        placeholder=" "
        value={value}
        onChange={onChange}
        minLength={minLength}
        maxLength={maxLength}
        onBlur={onBlur}
        placeholder={placeholder}
      />

      <label htmlFor={name} className={styles.label[theme]}>
        {label}
        {required ? "*" : ""}
      </label>

      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}

export default Textarea;
